module.exports = {
  OneClick: {
    PluginName: "Click",
  },
};
